export const MAKER = 'maker';
export const RETAILER = 'retailer';
export const THIRD_PARTY = 'third_party';
export const MANUFACTURER_TYPE = 1;
export const RETAILER_TYPE = 2;
export const PRIVATE_LABEL = 3;
export const THIRD_PARTY_TYPE = 4;
